import React from "react";
import { useRecoilValue } from "recoil";
import imgWelcome from "../../assets/images/welcome.svg";
import { permissionsSelector } from "../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../PermissionsConstants";
import { accountAtom } from "../Login/atoms/AccountAtom";
const Welcome = () => {
    const hasPermissions = useRecoilValue(permissionsSelector);
    const permissionsView = PERMISSIONS.permission_dashboard_view;

    const user = useRecoilValue(accountAtom);
    return (
        <div className=" bg-white p-4 rounded-xl shadow-2xl space-y-5">
            {hasPermissions.length === 0 ? (
                <div className="flex justify-between ">
                    <div className="m-8 p-3 ">
                        <h3 className="italic text-2xl 2xl:text-3xl font-normal text-primary leading-relaxed">
                            Welcome to{" "}
                        </h3>

                        <h1 className="text-primary font-bold text-2xl 2xl:text-4xl leading-normal ">
                            Confie Inquiry,{" "}
                            <p className="inline-block text-secondary font-semibold  welcomeFont italic">
                                {`${user.firstName}`}
                            </p>
                        </h1>
                        <hr className="borderWelcome" />
                        <h1 className="text-gray-500 font-semibold text-normal 2xl:text-xl leading-normal mt-6">
                            <strong>Contact</strong> your{" "}
                            <strong>System Administrator</strong> to{" "}
                            <strong>secure access</strong> to the modules.
                        </h1>
                    </div>

                    <div className="flex items-center">
                        <img src={imgWelcome} className="h-5/6 object-cover mx-auto" />
                    </div>
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default Welcome;
